import AuthService from '../../utilities/services/auth.service'
import { PromoterSalesReportsWrapper } from '../../components'

export default function PromoterSalesReportsPage() {
  const organization = AuthService.getOrg()[0]
  return <PromoterSalesReportsWrapper organization={organization} />
}
